import {
    Theme,
} from '@mui/material'
import {
    FieldConfig,
    SkyNetSpreadSheetCellType,
    SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    ForecastDataSpreadsheetColumnsConfig,
    ForecastSpreadsheetDataType,
} from '../../Forecast.types'

const getSingleForecastConfig = ({
    tmpFields,
    theme,
}: {
    tmpFields: ForecastDataSpreadsheetColumnsConfig,
    theme: Theme
}): SkyNetSpreadSheetConfigType<keyof ForecastSpreadsheetDataType> => {
    return {
        id: 'SingleForecast',
        maxHeight: window.screen.height - 120,
        headerRow: true,
        rowsCounter: false,
        addRowMenuOption: false,
        enableRangeSelection: true,
        enableRowSelection: true,
        stickyTopRows: 1,
        emptyRows: 0,
        initialFocusLocation: {
            columnId: 'account',
            rowId: 0,
        },
        fields: [
            {
                name: 'dataType',
                title: '',
                width: 120,
                disabled: true,
                cellConfig: {
                    type: SkyNetSpreadSheetCellType.TEXT,
                    style: {
                        background: theme.palette.common.white,
                    },
                },
            },
            ...tmpFields.map((fieldProps) => {
                return {
                    width: 100,
                    required: true,
                    defaultValue: null,
                    ...fieldProps,
                    cellConfig: {
                        type: SkyNetSpreadSheetCellType.NUMBER,
                        style: {
                            background: theme.palette.common.white,
                        },
                        ...fieldProps?.cellConfig || {},
                    },
                    disabled: fieldProps.disabled,
                }
            }),
            {
                name: 'id',
                width: 1,
                hidden: true,
                cellConfig: {
                    type: SkyNetSpreadSheetCellType.ID,
                },
            },
        ] as FieldConfig<keyof ForecastSpreadsheetDataType>[],
    }
}

export default getSingleForecastConfig
